export function getRoleDestination(rolNombre) {
    switch (rolNombre) {
        case 'admin':
        case 'inversor':
        case 'gestor_inmobiliario':
            return '/listado';
        case 'propietario':
            return '/mis-propiedades';
        case 'constructor':
        case 'interiorista':
        case 'perito':
            return '/analizarpropiedad/nueva';
        default:
            return '/select-role';
    }
}
